import dynamic from 'next/dynamic';

const SlideSummary = {
  getSettings: componentSettings => ({
    ...componentSettings
  }),
  VariantComponent: dynamic(() =>
    import(/* webpackChunkName: "blazePbVariantSlideSummary" */ './SlideSummary')
  )
};
export default SlideSummary;
